module.exports = __webpack_public_path__ + "static/media/pk1.73180697.png";